import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import TurboPower from 'turbo_power'
import "trix"
import "@rails/actiontext"
import "../libs/rich_text"
import "../controllers"
import "../turbo_mount"
import "chart.js"

ActiveStorage.start()

TurboPower.initialize(Turbo.StreamActions)

const confirmationDialog = (message, element) => {
  const dialog = document.getElementById("turbo_confirm")

  let {
    confirmTitle: titleText,
    confirmBody: bodyText,
    // Support both ui/button's confirm-btn-text/cancel-btn-text and the
    // older confirm-button/cancel-button attribute names.
    confirmBtnText,
    cancelBtnText,
    confirmButton,
    cancelButton,
    confirmVariant,
    hideConfirm
  } = element.dataset
  confirmBtnText = confirmBtnText || confirmButton
  cancelBtnText = cancelBtnText || cancelButton

  titleText = titleText || dialog.dataset.titleText
  bodyText = bodyText || dialog.dataset.bodyText
  confirmBtnText = confirmBtnText || dialog.dataset.confirmText
  cancelBtnText = cancelBtnText || dialog.dataset.cancelText
  confirmVariant = confirmVariant || dialog.dataset.variant

  dialog.querySelector('[data-title]').innerText = titleText
  dialog.querySelector('[data-body]').innerHTML = bodyText
  dialog.querySelector('[data-confirm]').innerText = confirmBtnText
  dialog.querySelector('[data-cancel]').innerText = cancelBtnText
  dialog.setAttribute('data-variant', confirmVariant)

  if (hideConfirm) {
    dialog.querySelector('[data-confirm]').classList.add('hidden')
  }

  dialog.classList.remove('hidden')

  // Hide any open ui/modal(s) behind the confirmation so the dialogs don't
  // stack. Restore them if the user cancels; leave them hidden on confirm
  // (whatever action follows will replace the page / modal anyway, and
  // restoring would briefly re-flash the old modal).
  const hiddenModals = Array.from(document.querySelectorAll('[role="dialog"]'))
    .filter(el => el !== dialog && el.offsetParent !== null)
  hiddenModals.forEach(el => el.classList.add('invisible'))

  const restoreHiddenModals = () => {
    hiddenModals.forEach(el => el.classList.remove('invisible'))
  }

  dialog.showModal()
  dialog.focus()

  const cancelBtn = dialog.querySelector('[data-cancel]')
  const closeIconBtn = dialog.querySelector('button[value="cancel"][aria-label]')

  // Form method="dialog" submits don't reliably fire a `close` event in every
  // environment, so bind directly to the cancel buttons' clicks.
  const onCancel = () => restoreHiddenModals()
  cancelBtn?.addEventListener('click', onCancel, { once: true })
  closeIconBtn?.addEventListener('click', onCancel, { once: true })

  return new Promise((resolve, reject) => {
    dialog.addEventListener("close", () => {
      dialog.classList.add('hidden')

      if (dialog.returnValue !== "confirm") {
        restoreHiddenModals()
      }

      document.querySelectorAll('[data-loading="true"]').forEach(el => {
        el.removeAttribute('data-loading')
      })

      resolve(dialog.returnValue === "confirm")
    }, { once: true })
  })
}

window.confirmationDialog = confirmationDialog

// custom confirm dialog
Turbo.setConfirmMethod(confirmationDialog)
